/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface RegistrationStatusDto
 */
export interface RegistrationStatusDto {

    /**
     * @type {number}
     * @memberof RegistrationStatusDto
     */
    id: number;

    /**
     * @type {string}
     * @memberof RegistrationStatusDto
     */
    status: RegistrationStatusDtoStatusEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum RegistrationStatusDtoStatusEnum {
    Registered = 'registered',
    Updated = 'updated',
    AlreadyRegistered = 'already_registered'
}

